module.exports = __webpack_public_path__ + "img/fenxiang.17dc00cb.png";